import ModalDefault from "../modal-default";
import React from "react";
import LoadDispatchItems from "../load-dispatch-items";

export default function LoadsDispatchItemsModal({show, onClose, selectedItem, translate}) {
    return <ModalDefault
        show={show}
        title={selectedItem?.LoadNumber ? translate('text.dispatch_history_no', [selectedItem.LoadNumber]) : translate('text.dispatch_history')}
        widthClass="max-w-2xl"
        onClose={onClose}
        closeButtonLabel={translate("btn.close")}
    >

        {!!selectedItem?.Switches && (
            <LoadDispatchItems switches={selectedItem?.Switches} translate={translate}/>
        )}
    </ModalDefault>
}
